import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import DiamondContractor from "../views/DiamondContractor.vue";
import DuctlessSolutions from "../views/DuctlessSolutions.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/about",
    name: "about",
    component: About
  },
  {
    path: "/ductless",
    name: "ductless",
    component: DuctlessSolutions
  },
  {
    path: "/diamond-contractor",
    name: "diamond-contractor",
    component: DiamondContractor
  },
  {
    path: "/contactus",
    name: "contactus",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ContactUs.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
